import apiUrl from '../../../../constants'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'push-bag-details',
  components: { VueElementLoading },
  props: ['hubid','hubname'],
  data() {
    return {
      isLoading: false,
      bagNoLimit: '',
      bagNoLimitMsg: '',
      bagNo: ''
    }
  },
  computed: {},
  filters: {},
  mounted() { },
  methods: {
    pushBagNoDetails() {
      this.$validator.validateAll().then((result) => {
        this.bagNoLimit = ''
        this.bagNoLimitMsg = ''
        if (this.bagNo != '') {
          this.isLoading = true
          if (/\r?\n|\r/g.test(this.bagNo) == true) {
            this.bagNo = this.bagNo.replace(/\r?\n|\r/g, ',');
          }
          if (/\s/g.test(this.bagNo) == true) {
            this.bagNo = this.bagNo.replace(/\n|"|'| |,\s*$/g, '');
          }
          let bagNoArray = []
          if (this.bagNo.indexOf(',') == -1) {
            bagNoArray.push(this.bagNo);
          } else {
            bagNoArray = this.bagNo.split(',');
          }
          if (bagNoArray.length > 50000) {
            this.isLoading = false
            this.bagNoLimit = true
            this.bagNoLimitMsg = "Please enter bag no's quantity upto 50,000"
            return false;
          }
          let inputArray = ''
          for (const element of bagNoArray) {
            if (element.length > 0) {
              if (inputArray == '' || inputArray.length < 1)
                inputArray = element
              else
                inputArray = inputArray + `','` + element
            }
          }
          if(!inputArray || inputArray.length < 0){
            this.isLoading = false
            this.bagNoLimit = true
            this.bagNoLimitMsg = "Please enter valid bag numbers"
            return false;
          }
          this.input = ({
            SorterLocation: this.hubid,
            BagNoList: `'` + inputArray + `'`
          })
          axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'pushBagNoDetails',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25'
            }
          })
            .then(result => {
              this.isLoading = false;
              if (result.data.ResultCode == 100) {
                this.$alertify.success(result.data.ReturnMessage)
                this.clearID()
              } else {
                this.$alertify.error(result.data.ReturnMessage)
              }
            }, error => {
              console.error(error)
              this.isLoading = false
            })
        }
      }).catch((errors) => {
        console.log('errors exist', errors)
      });
    },
    clearID() {
      this.isLoading = false;
      this.bagNoLimit = '';
      this.bagNoLimitMsg = '';
      this.bagNo = '';
      this.$validator.reset();
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/BagSorter/PushBagDetails/PushBagDetails.js